"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCallable = createCallable;
exports.getChanges = getChanges;
Object.defineProperty(exports, "getEventsFromInput", {
  enumerable: true,
  get: function () {
    return _events.getEventsFromInput;
  }
});
exports.invokeArrayQuery = invokeArrayQuery;
exports.isString = isString;
exports.wrapDisplayName = wrapDisplayName;

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _some2 = _interopRequireDefault(require("lodash/some"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _constant2 = _interopRequireDefault(require("lodash/constant"));

var _events = require("./events");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isString(varToCheck) {
  return typeof varToCheck === 'string' || varToCheck instanceof String;
}

function createCallable(f) {
  return typeof f === 'function' ? f : (0, _constant2.default)(f);
}

function invokeArrayQuery(f, props) {
  const result = createCallable(f)(props);

  if (Array.isArray(result)) {
    return result;
  }

  if (!result) {
    return null;
  }

  return [result];
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
}

function wrapDisplayName(BaseComponent, hocName) {
  return `${hocName}(${getDisplayName(BaseComponent)})`;
}

function getChanges() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let prevData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const result = {};
  result.added = (0, _filter2.default)(data, d => !(0, _some2.default)(prevData, p => (0, _isEqual2.default)(d, p)));
  result.removed = (0, _filter2.default)(prevData, p => !(0, _some2.default)(data, d => (0, _isEqual2.default)(p, d)));
  return result;
}